const COMPETITORS = [
  { name: 'Software de Inventario', price: 180000, icon: '📦' },
  { name: 'Software de Facturacion', price: 120000, icon: '🧾' },
  { name: 'Agendamiento / CRM',      price: 130000, icon: '📅' },
];

const FEATURES = [
  { label: 'Control de inventario completo'       },
  { label: 'Facturacion y cuentas de cobro'        },
  { label: 'Agendamiento y CRM de clientes'        },
  { label: 'IA de compras inteligentes'            },
  { label: 'Reportes financieros en tiempo real'   },
  { label: 'Vista cliente del servicio en vivo'    },
  { label: 'Historial completo del cliente'        },
  { label: 'Landing page propia del negocio'       },
  { label: 'QR personalizado para clientes'        },
  { label: 'Soporte y actualizaciones incluidos'   },
];

const TOTAL_COMPETITORS = COMPETITORS.reduce((sum, c) => sum + c.price, 0);
const PRICE_FULL  = 230000;
const PRICE_EARLY = 130000;
const DISCOUNT_PCT = Math.round((1 - PRICE_EARLY / PRICE_FULL) * 100);
const SAVINGS = PRICE_FULL - PRICE_EARLY;

const fmt = (n) => n.toLocaleString('es-CO');

const CheckIcon = () => (
  <svg className="w-5 h-5 text-brand-400 flex-shrink-0" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5 text-red-400 flex-shrink-0" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const Pricing = () => (
  <section id="precios" className="py-24 bg-dark relative overflow-hidden">

    {/* Fondo */}
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.12) 0%, transparent 70%)', filter: 'blur(80px)' }} />
    </div>

    <div className="max-w-6xl mx-auto px-5 relative">

      {/* Encabezado */}
      <div className="text-center mb-16">
        <span className="inline-block bg-brand-500/15 text-brand-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-brand-500/20">
          Planes y Precios
        </span>
        <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
          Todo lo que tu negocio necesita.<br />
          <span className="text-brand-400">En un solo lugar.</span>
        </h2>
        <p className="text-white/40 mt-4 text-lg max-w-xl mx-auto">
          Los negocios de la competencia pagan mas de{' '}
          <span className="text-white font-bold">${fmt(TOTAL_COMPETITORS)}/mes</span>{' '}
          y todavia usan 3 apps distintas sin integracion.
        </p>
      </div>

      {/* Comparativa */}
      <div className="grid md:grid-cols-2 gap-6 mb-10">

        {/* Columna: La competencia */}
        <div className="glass-card rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 bg-red-500/15 rounded-lg flex items-center justify-center border border-red-500/20">
              <XIcon />
            </div>
            <div>
              <p className="text-white font-bold text-sm">Lo que hacen los demas</p>
              <p className="text-white/35 text-xs">Pagar 3 software por separado</p>
            </div>
          </div>
          <div className="space-y-3 mb-6">
            {COMPETITORS.map((c) => (
              <div key={c.name} className="flex items-center justify-between rounded-xl px-4 py-3"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}>
                <div className="flex items-center gap-2">
                  <span className="text-lg">{c.icon}</span>
                  <span className="text-white/60 text-sm">{c.name}</span>
                </div>
                <span className="text-red-400 font-bold text-sm">${fmt(c.price)}/mes</span>
              </div>
            ))}
          </div>
          <div className="border-t border-white/8 pt-4 flex items-center justify-between">
            <span className="text-white/35 text-sm">Total mensual</span>
            <div className="text-right">
              <p className="text-red-400 font-black text-2xl">${fmt(TOTAL_COMPETITORS)}<span className="text-sm font-normal">/mes</span></p>
              <p className="text-white/25 text-xs">Sin integracion · Sin soporte unificado</p>
            </div>
          </div>
        </div>

        {/* Columna: Nexo Pro */}
        <div className="rounded-2xl p-6 relative overflow-hidden shadow-2xl"
          style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #7c3aed 50%, #8b5cf6 100%)' }}>
          <div className="absolute top-4 right-4">
            <span className="bg-white text-brand-700 text-xs font-black px-3 py-1 rounded-full shadow-lg">
              LANZAMIENTO
            </span>
          </div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 bg-white/20 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <div>
              <p className="text-white font-bold text-sm">Nexo Pro 360</p>
              <p className="text-white/70 text-xs">Todo en uno · Un solo pago mensual</p>
            </div>
          </div>

          <div className="space-y-2 mb-6">
            {FEATURES.map((f) => (
              <div key={f.label} className="flex items-center gap-2">
                <svg className="w-4 h-4 text-white flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span className="text-white/90 text-sm">{f.label}</span>
              </div>
            ))}
          </div>

          <div className="border-t border-white/20 pt-4">
            <p className="text-white/60 text-xs font-bold uppercase tracking-wider mb-2">Un solo precio mensual</p>
            <div className="flex items-end gap-3">
              <p className="text-white/40 line-through text-lg font-bold">${fmt(PRICE_FULL)}</p>
              <p className="text-white font-black text-4xl">${fmt(PRICE_EARLY)}<span className="text-base font-normal">/mes</span></p>
            </div>
            <p className="text-white/70 text-sm mt-1">
              Ahorras <span className="text-white font-black">${fmt(SAVINGS)}/mes</span> — {DISCOUNT_PCT}% de descuento
            </p>
          </div>
        </div>
      </div>

      {/* Banner urgencia */}
      <div className="glass-card rounded-2xl p-6 md:flex items-center justify-between gap-6 mb-8">
        <div className="flex items-start gap-4 mb-5 md:mb-0">
          <div className="text-3xl flex-shrink-0">🚀</div>
          <div>
            <p className="text-white font-black text-lg">Precio de lanzamiento — solo los primeros 20 negocios</p>
            <p className="text-white/40 text-sm mt-1">
              Despues de los 20 primeros registros el precio sube a{' '}
              <span className="text-white font-bold">${fmt(PRICE_FULL)}/mes</span>.{' '}
              Entra ahora y bloquea <span className="text-brand-400 font-bold">{DISCOUNT_PCT}% de ahorro permanente</span> mientras seas cliente activo.
            </p>
          </div>
        </div>
        <a href="#contacto"
          className="flex-shrink-0 inline-block text-white font-black text-sm px-8 py-4 rounded-xl transition-all shadow-lg hover:opacity-90 hover:scale-105 whitespace-nowrap"
          style={{ background: 'linear-gradient(135deg, #6d28d9, #8b5cf6)', boxShadow: '0 8px 24px rgba(124,58,237,0.4)' }}>
          Registrar mi Negocio →
        </a>
      </div>

      <p className="text-center text-white/25 text-sm">
        Sin contratos de permanencia · Cancela cuando quieras · Soporte incluido
      </p>

    </div>
  </section>
);

export default Pricing;
